// HOOKS
import useMultiSelectStore from "../hooks/useMultiSelectStore.hook";

import LogicalOperatorsDropdown from "../dropdowns/logicalOperators.dropdown.advancedQuery";
import MultiSelectDropdown from "../dropdowns/multiSelect.dropdown.advancedQuery";
import { useEffect } from "react";
import StringInput from "../typeInputs/string/string.typeInput";
import NumberInput from "../typeInputs/number/number.typeInput";
import DateInput from "../typeInputs/date/date.typeInput";

const ticketOptions = {
  classNames: {
    dropdownButton: {
      dropdown:
        "border-animate rounded h-[250px] w-[250px] overflow-y-scroll absolute backdrop-blur-sm bg-greenGlass flex flex-col gap-1 p-2 top-11 z-20",
    },
  },
};
const ticketFields = [
  {
    value: "asset_ids",
    label: "Asset IDs",
    name: "asset_ids",
    checked: false,
    type: "array",
  },
  {
    value: "assets",
    label: "Assets",
    name: "assets",
    checked: false,
    type: "object",
  },
  {
    value: "comments",
    label: "Comments",
    name: "comments",
    checked: false,
    type: "array",
  },
  {
    value: "contact",
    label: "Contact",
    name: "contact",
    checked: false,
    type: "object",
  },
  {
    value: "created_at",
    label: "Created At",
    name: "created_at",
    checked: false,
    type: "date",
  },
  {
    value: "customer",
    label: "Customer",
    name: "customer",
    checked: false,
    type: "object",
  },
  {
    value: "customer_business_then_name",
    label: "Customer Business Name",
    name: "customer_business_then_name",
    checked: false,
    type: "string",
  },
  {
    value: "customer_id",
    label: "Customer ID",
    name: "customer_id",
    checked: false,
    type: "number",
  },
  { value: "_id", label: "ID", name: "_id", checked: false, type: "String" },
  {
    value: "invoices",
    label: "Invoices",
    name: "invoices",
    checked: false,
    type: "array",
  },
  {
    value: "line_items",
    label: "Line Items",
    name: "line_items",
    checked: false,
    type: "array",
  },
  {
    value: "problem_type",
    label: "Problem Type",
    name: "problem_type",
    checked: false,
    type: "string",
  },
  {
    value: "properties",
    label: "Properties",
    name: "properties",
    checked: false,
    type: "object",
  },
  { value: "id", label: "RS ID", name: "id", checked: false, type: "number" },
  {
    value: "received_at",
    label: "Received At",
    name: "received_at",
    checked: false,
    type: "date",
  },
  {
    value: "resolved_at",
    label: "Resolved At",
    name: "resolved_at",
    checked: false,
    type: "date",
  },
  {
    value: "status",
    label: "Status",
    name: "status",
    checked: false,
    type: "string",
  },
  {
    value: "status_changes",
    label: "Status Changes",
    name: "status_changes",
    checked: false,
    type: "array",
  },
  {
    value: "subject",
    label: "Subject",
    name: "subject",
    checked: false,
    type: "string",
  },
  {
    value: "ticket_answers",
    label: "Ticket Answers",
    name: "ticket_answers",
    checked: false,
    type: "array",
  },
  {
    value: "ticket_fields",
    label: "Ticket Fields",
    name: "ticket_fields",
    checked: false,
    type: "array",
  },
  {
    value: "number",
    label: "Ticket Number",
    name: "number",
    checked: false,
    type: "number",
  },
  {
    value: "ticket_type",
    label: "Ticket Type",
    name: "ticket_type",
    checked: false,
    type: "object",
  },
  {
    value: "updated_at",
    label: "Updated At",
    name: "updated_at",
    checked: false,
    type: "date",
  },
  {
    value: "user_id",
    label: "User ID",
    name: "user_id",
    checked: false,
    type: "number",
  },
  {
    value: "worksheet_results",
    label: "Worksheet Results",
    name: "worksheet_results",
    checked: false,
    type: "array",
  },
];

const MatchAdvancedQuery = ({ match, setMatch }) => {
  const { options: fields, handleChange: handleFieldsChange } =
    useMultiSelectStore({ defaultOptions: ticketFields });
  const checkedFields = fields.filter((field) => field.checked);

  const handleInitialLOChange = (event) => {
    const { value } = event.target;
    setMatch({ [value]: match[Object.keys(match)[0]] });
  };

  useEffect(() => {
    setMatch((prevMatch) => ({
      ...prevMatch,
      [Object.keys(prevMatch)[0]]: checkedFields.map((field) => ({
        [field.value]: "",
      })),
    }));
  }, [fields]);

  return (
    <div className="font-ubuntuRegular flex flex-col shadow-secondary shadow rounded px-4 py-2 w-full justify-center">
      <h2 className="shadow shadow-secondary bg-slate-200 rounded text-center font-bold">
        Match
      </h2>
      <p>{JSON.stringify(match)}</p>
      <div className="gap-2 flex flex-col  rounded px-4 py-2 w-full justify-center">
        <LogicalOperatorsDropdown
          handleChange={handleInitialLOChange}
          value={Object.keys(match)[0]}
        />
        <div className="gap-2 flex flex-col rounded px-4 py-2 w-full justify-center">
          <MultiSelectDropdown
            options={fields}
            handleChange={handleFieldsChange}
            dropdownButtonProps={{
              label: "Fields",
              value: 0,
              classNames: ticketOptions.classNames.dropdownButton,
            }}
          />
          <div>
            {checkedFields.length > 0 &&
              checkedFields.map((field, index) => {
                if (field.type === "string") {
                  return <StringInput field={field} setMatch={setMatch} />;
                }
                if (field.type === "number") {
                  return <NumberInput field={field} setMatch={setMatch} />;
                }
                if (field.type === "date") {
                  return <DateInput field={field} setMatch={setMatch} />;
                }
                return <label>Stuff</label>;
              })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MatchAdvancedQuery;
